//This is  functional component containing all the information displayed on the
//Support page
function Support() {

    return (
        <div className='body'>
            <h2 id='welcome'>You are Welcome to the home of The Mystic Creatures Support Page...</h2>
            <h4 id='detail'>
                <p>For any assistance or support, reach out to me through any of these channels</p>
                <p>E-mail: okeke.michael1995@gmail.com</p>
                <p>WhatsApp: +2348032205968</p>
                <p>Call: +2348032205968</p>
                <p>Also, drop a direct message to me on twitter or facebook using the icons below</p>
            </h4>
        </div>
    )
}

export default Support